import React, { useContext } from "react";
import { Link } from "react-router-dom";
import { Pencil, Trash, Plus } from "tabler-icons-react";
import event from "../assets/profile.jpg";
import { MenuContext } from "../context/menuContext";
import icon from "../assets/info2.png";

function Events() {
	const { mobileMenu } = useContext(MenuContext);

	return (
		<div
			className={
				mobileMenu
					? "overflow-y-hidden absolute md:left-64 md:top-0 md:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
					: "absolute top-[3rem] md:left-[13rem] lg:left-64 md:top-0 md:w-[calc(100%-13rem)] lg:w-[calc(100%-16rem)] py-3 h-auto bg-slate-50 dark:bg-darkbg"
			}>
			<div className="flex justify-between items-center px-5 border-b border-b-slate-100 dark:border-b-darkborder">
				<h1 className="text-slate-500 dark:text-darktext uppercase font-semibold">
					All Events <span>(12)</span>
				</h1>
				<Link
					to="/events/new"
					className="flex items-center border border-sky-200 dark:border-darkborder px-3 py-1 text-slate-600 dark:text-darktext rounded-sm hover:bg-sky-500 hover:dark:bg-darkbtnhover hover:text-white hover:dark:text-darkbtntxthv transition-all duration-150 ease-in-out">
					<Plus className="mr-1" /> Add event
				</Link>
			</div>
			<div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-y-2 md:gap-2 mt-3 px-5">
				<div className="shadow-sm rounded-md bg-white dark:bg-darkbg dark:border dark:border-darkborder">
					<img
						src={event}
						alt="event"
						className="object-cover rounded-t-md w-full h-44"
					/>
					<div className="flex justify-between py-3 px-2 border-b dark:border-b-darkborder">
						<span className="font-medium w-2/3 truncate">
							Tech Talk: Verudela Beach
						</span>
						<span className="font-code bg-sky-100 dark:bg-darkbtn rounded-md px-1 text-sky-500 text-sm">
							Nariobi, KE
						</span>
					</div>
					<p className="text-sm text-slate-600 dark:text-darktext py-[.35rem] leading-relaxed px-2 line-clamp-4 border-b dark:border-b-darkborder">
						Completely renovated for the season 2020, Arena Verudela Bech
						Apartments are fully equipped and modernly furnished 4-star
						self-service apartments located on the Adriatic coastline by one of
						the most beautiful beaches in Pula.
					</p>
					<div className="border-b uppercase text-slate-400 py-2 px-2">
						<span className="text-sm font-medium">tags, what will happen</span>
						<div className="flex items-center gap-x-4 gap-y-1 flex-wrap text-xs text-slate-600 font-medium">
							<span className="flex items-center">
								<img src={icon} alt="icon" className="w-3 h-3 mr-1" /> coding
							</span>
							<span className="flex items-center">
								<img src={icon} alt="icon" className="w-3 h-3 mr-1" />
								qa
							</span>
							<span className="flex items-center">
								<img src={icon} alt="icon" className="w-3 h-3 mr-1" />
								career advice
							</span>
							<span className="flex items-center">
								<img src={icon} alt="icon" className="w-3 h-3 mr-1" />
								hygiene
							</span>
							<span className="flex items-center">
								<img src={icon} alt="icon" className="w-3 h-3 mr-1" />
								keeping healthy
							</span>
						</div>
					</div>
					<div className="flex py-2 pr-2 space-x-3">
						<Link to="/events/:id" className="ml-auto">
							<Pencil className="border border-slate-300 hover:bg-sky-100 hover:dark:bg-darkbtnhover transition-all duration-150 ease-in-out p-1 rounded-md text-sky-500" />
						</Link>
						<Trash className="cursor-pointer border border-slate-300 hover:bg-sky-100 hover:dark:bg-darkbtnhover transition-all duration-150 ease-in-out p-1 rounded-md text-red-500" />
					</div>
				</div>
			</div>
		</div>
	);
}

export default Events;
